import { useState } from 'react';
import { CabeceraPagina } from '../components/Armazon';
import { Aviso, Boton, Campo, Tarjeta } from '../components/ui';
import { ApiError, api } from '../lib/api';
import { ROL_ETIQUETA } from '../lib/formato';
import { useAvisos, useSesion } from '../lib/sesion';

export function Cuenta() {
  const { usuario, refrescar } = useSesion();
  const { avisar } = useAvisos();
  const [actual, setActual] = useState('');
  const [nueva, setNueva] = useState('');
  const [repetida, setRepetida] = useState('');
  const [fallo, setFallo] = useState<string | null>(null);
  const [guardando, setGuardando] = useState(false);

  async function cambiar() {
    setFallo(null);
    if (nueva !== repetida) {
      setFallo('Las dos contraseñas nuevas no coinciden.');
      return;
    }
    setGuardando(true);
    try {
      await api.post('/auth/change-password', { currentPassword: actual, newPassword: nueva });
      avisar('Contraseña actualizada.', 'hecho');
      setActual('');
      setNueva('');
      setRepetida('');
      await refrescar();
    } catch (e) {
      setFallo(e instanceof ApiError ? e.message : 'No se ha podido cambiar la contraseña.');
    } finally {
      setGuardando(false);
    }
  }

  return (
    <>
      <CabeceraPagina titulo="Mi cuenta" />

      <div className="rejilla dos">
        <Tarjeta titulo="Datos">
          <dl className="bloque" style={{ margin: 0 }}>
            <dt>Nombre</dt>
            <dd>{usuario!.name}</dd>
            <dt>Correo</dt>
            <dd>{usuario!.email}</dd>
            <dt>Perfil</dt>
            <dd>{ROL_ETIQUETA[usuario!.role]}</dd>
            {usuario!.salespersonExternalId && (
              <>
                <dt>Id. de vendedor</dt>
                <dd className="dato">{usuario!.salespersonExternalId}</dd>
              </>
            )}
          </dl>
        </Tarjeta>

        <Tarjeta titulo="Cambiar contraseña">
          <div className="pila">
            {usuario!.mustChangePassword && (
              <Aviso tono="aviso">Debe cambiar la contraseña temporal antes de seguir trabajando.</Aviso>
            )}
            {fallo && <Aviso tono="error">{fallo}</Aviso>}
            <Campo etiqueta="Contraseña actual">
              <input type="password" value={actual} autoComplete="current-password" onChange={(e) => setActual(e.target.value)} />
            </Campo>
            <Campo etiqueta="Nueva contraseña" ayuda="Al menos 10 caracteres.">
              <input type="password" value={nueva} autoComplete="new-password" onChange={(e) => setNueva(e.target.value)} />
            </Campo>
            <Campo etiqueta="Repita la nueva contraseña">
              <input type="password" value={repetida} autoComplete="new-password" onChange={(e) => setRepetida(e.target.value)} />
            </Campo>
            <div className="fila" style={{ justifyContent: 'flex-end' }}>
              <Boton
                variante="clave"
                cargando={guardando}
                disabled={!actual || nueva.length < 10}
                onClick={cambiar}
              >
                Cambiar contraseña
              </Boton>
            </div>
          </div>
        </Tarjeta>
      </div>
    </>
  );
}
